export default "__VITE_ASSET__b8a10df3__"